import $ from 'jquery';
import run from '../../utilities/run';

run("#notification-preferences-detail", ()=>{
	const el = $("#notification-preferences-detail");
  	notificationPreferenceDetail(el);
});

function notificationPreferenceDetail(el){
	const editPageUrl=el.data("edit-notification-preference-url");
  	let workOrderNotifcationConfig = el.data("workorder-notification-config");
  	let orderErrorNotifcationConfig = el.data("order-error-notification-config");

  	const els = {};
  	const elementsMap ={
  		
  	}
}


// WEBPACK FOOTER //
// ./src/pages/notificationPreferences/notificationPreferenceDetailsPage.js